var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AppSwitch',{attrs:{"value":_vm.isDarkTheme,"disabled":!_vm.availableOptionalProps,"text":_vm.hideText ? '' : 'Темная тема'},on:{"input":_vm.setTheme}})
}
var staticRenderFns = []

export { render, staticRenderFns }